const AUTOSAVE_PREF_KEY = 'storageBox.textEditor.autosaveEnabled';

export function readStorageBoxTextEditorAutosaveEnabled() {
  try {
    const raw = localStorage.getItem(AUTOSAVE_PREF_KEY);
    if (raw === '0' || raw === 'false') return false;
    return true;
  } catch {
    return true;
  }
}

export function writeStorageBoxTextEditorAutosaveEnabled(enabled) {
  try {
    localStorage.setItem(AUTOSAVE_PREF_KEY, enabled ? '1' : '0');
  } catch {
    /* ignore quota / private mode */
  }
}

export const STORAGE_BOX_TEXT_EDITOR_AUTOSAVE_DEBOUNCE_MS = 900;
